import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuetify from 'vuetify/lib'

import App from './App.vue'
import router from './router'
import store from './store'
import './filters'

import ErrorDialog from '@/components/ErrorDialog';
Vue.component('error-dialog', ErrorDialog)

Vue.config.productionTip = false

Vue.use(VueResource);

Vue.use(Vuetify);
// Translation provided by Vuetify (javascript)
import pt from 'vuetify/es5/locale/pt'
const vuetify = new Vuetify({
	lang: {
		locales: { pt },
		current: 'pt',
	},
	theme: {
		themes: {
			light: {
				primary: '#296eaf',
				secondary: '#61a6c7',
				accent: '#09419f',
				error: '#b71c1c'
			}
		}
	},
	icons: {
		iconfont: 'md',
	}
})

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount('#app')